import { createSelector } from '@reduxjs/toolkit';
import { ChromosomesService } from 'Common/services';
export const getState = (rootState) => rootState.cacheData;
export const getChromosomesLoaded = createSelector([getState], ({ chromosomes }) => !ChromosomesService.isEmpty(chromosomes));
export const getChromosomes = createSelector([getState], ({ chromosomes }) => chromosomes);
